"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LIST_PROJECT_USER_AUTH = void 0;
const react_1 = __importStar(require("react"));
const schema_1 = __importDefault(require("./schema"));
const schemaComponents_1 = require("@/schemaComponents");
const models_hook_1 = require("app/models.hook");
const route_1 = require("../route");
const auth_1 = require("common/auth");
const index_1 = require("../../../../index");
exports.LIST_PROJECT_USER_AUTH = route_1.USER_AUTHS.sub("/list", UserAuths);
function UserAuths({ projectId }) {
    (0, auth_1.useProjectPageAuthorization)(projectId);
    const { conditionSelector, condition } = (0, schemaComponents_1.useConditionSelector)({
        schema: schema_1.default,
        hideTimeCondition: true,
    });
    const { list, loading, hasMore, refresher, fetching, reload, setRange, get } = (0, models_hook_1.useProjectAuthEmailList)({
        projectId,
        condition,
    });
    const parameter = (0, react_1.useMemo)(() => ({
        title: "プロジェクトユーザ一覧",
        edit: {
            path: ({ email }) => (0, index_1.resolveRoute)("UPDATE_PROJECT_USER_AUTH", { email, projectId }),
        },
        create: {
            path: () => (0, index_1.resolveRoute)("CREATE_PROJECT_USER_AUTH", { projectId }, {
                searchParams: { edit: "1" },
            }),
        },
        download: {
            filename: `userAuths`,
            handler: get,
        },
        schema: schema_1.default,
        setRange,
    }), [schema_1.default, setRange]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(schemaComponents_1.SchemaListPage, { parameter: parameter, list: list, loading: loading, hasMore: hasMore, fetching: fetching, refresher: refresher, header: conditionSelector, reload: reload })));
}
exports.default = UserAuths;
